module.exports = __webpack_public_path__ + "img/w_o_l.e1106ee4.png";